import { Injectable } from '@angular/core';

@Injectable()
export class PageBackofficeService {

  private _addSerial : boolean = false;
  private _editSerial: boolean = false;
  private _deleteSerial: boolean = false;
  private _addProcedure : boolean = false;
  private _editProcedure: boolean = false;
  private _cloneProcedure: boolean = false;
  private _cloneTranslations: boolean = false;

  private _deleteProcedure: boolean = false;
  private _addStep : boolean = false;
  private _editStep: boolean = false;
  private _deleteStep: boolean = false;

  private _addArticleCode: boolean = false;
  private _editArticleCode: boolean = false;
  private _deleteArticleCode: boolean = false;

  private _addDocument: boolean = false;
  private _editDocument: boolean = false;
  private _deleteDocument: boolean = false;

  private _addNews: boolean = false;
  private _editNews: boolean = false;
  private _deleteNews: boolean = false;

  private _addEvent: boolean = false;
  private _editEvent: boolean = false;
  private _deleteEvent: boolean = false;

  private _addAcademy: boolean = false;
  private _editAcademy: boolean = false;
  private _deleteAcademy: boolean = false;

  private _deleteMedia: boolean = false;


  private _addMaintenance: boolean = false;
  private _editMaintenance: boolean = false;
  private _cloneMaintenance: boolean = false;
  private _cloneMaintenanceTranslations: boolean = false;
  private _deleteMaintenance: boolean = false;

  private _addMaintenanceCheck: boolean = false;
  private _editMaintenanceCheck: boolean = false;
  private _deleteMaintenanceCheck: boolean = false;

  private _addProductFamily: boolean = false;
  private _editProductFamily: boolean = false;
  private _deleteProductFamily: boolean = false;
  
  private _addSerialNumberButton: boolean = false;
  private _addButton: boolean = false;
  private _importSerialNumberButton: boolean = false;
  private _addMedia: boolean = false;

  constructor() { }

  get addMedia() {
    return this._addMedia;
  }

  set addMedia(value: boolean) {
    this._addMedia = value;
  }

  get addSerial() {
    return this._addSerial;
  }

  set addSerial(value : boolean) {
    this._addSerial = value;
  }

  get editSerial() {
    return this._editSerial;
  }

  set editSerial(value : boolean) {
    this._editSerial = value;
  }

  public get deleteSerial(): boolean {
    return this._deleteSerial;
  }
  public set deleteSerial(value: boolean) {
    this._deleteSerial = value;
  }

  get addProcedure() {
    return this._addProcedure;
  }

  set addProcedure(value : boolean) {
    this._addProcedure = value;
  }

  get editProcedure() {
    return this._editProcedure;
  }

  set editProcedure(value : boolean) {
    this._editProcedure = value;
  }

  get cloneProcedure() {
    return this._cloneProcedure;
  }

  set cloneProcedure(value : boolean) {
    this._cloneProcedure = value;
  }

  get cloneTranslations() {
    return this._cloneTranslations;
  }

  set cloneTranslations(value : boolean) {
    this._cloneTranslations = value;
  }

  public get deleteProcedure(): boolean {
    return this._deleteProcedure;
  }
  public set deleteProcedure(value: boolean) {
    this._deleteProcedure = value;
  }

  get addStep() {
    return this._addStep;
  }

  set addStep(value : boolean) {
    this._addStep = value;
  }

  get editStep() {
    return this._editStep;
  }

  set editStep(value : boolean) {
    this._editStep = value;
  }

  public get deleteStep(): boolean {
    return this._deleteStep;
  }
  public set deleteStep(value: boolean) {
    this._deleteStep = value;
  }

  public get deleteArticleCode(): boolean {
    return this._deleteArticleCode;
  }
  public set deleteArticleCode(value: boolean) {
    this._deleteArticleCode = value;
  }

  public get deleteDocument(): boolean {
    return this._deleteDocument;
  }
  public set deleteDocument(value: boolean) {
    this._deleteDocument = value;
  }

  public get deleteNews(): boolean {
    return this._deleteNews;
  }
  public set deleteNews(value: boolean) {
    this._deleteNews = value;
  }

  public get deleteMaintenance(): boolean {
    return this._deleteMaintenance;
  }
  public set deleteMaintenance(value: boolean) {
    this._deleteMaintenance = value;
  }

  public get deleteMaintenanceCheck(): boolean {
    return this._deleteMaintenanceCheck;
  }
  public set deleteMaintenanceCheck(value: boolean) {
    this._deleteMaintenanceCheck = value;
  }

  public get addArticleCode(): boolean {
    return this._addArticleCode;
  }
  public set addArticleCode(value: boolean) {
    this._addArticleCode = value;
  }

  public get editArticleCode(): boolean {
    return this._editArticleCode;
  }
  public set editArticleCode(value: boolean) {
    this._editArticleCode = value;
  }

  public get addDocument(): boolean {
    return this._addDocument;
  }
  public set addDocument(value: boolean) {
    this._addDocument = value;
  }

  public get editDocument(): boolean {
    return this._editDocument;
  }
  public set editDocument(value: boolean) {
    this._editDocument = value;
  }

  public get addNews(): boolean {
    return this._addNews;
  }
  public set addNews(value: boolean) {
    this._addNews = value;
  }

  public get editNews(): boolean {
    return this._editNews;
  }
  public set editNews(value: boolean) {
    this._editNews = value;
  }

  public get addEvent(): boolean {
    return this._addEvent;
  }
  public set addEvent(value: boolean) {
    this._addEvent = value;
  }

  public get editEvent(): boolean {
    return this._editEvent;
  }
  public set editEvent(value: boolean) {
    this._editEvent = value;
  }

  public get addAcademy(): boolean {
    return this._addAcademy;
  }
  public set addAcademy(value: boolean) {
    this._addAcademy = value;
  }

  public get editAcademy(): boolean {
    return this._editAcademy;
  }
  public set editAcademy(value: boolean) {
    this._editAcademy = value;
  }

  public get deleteAcademy(): boolean {
    return this._deleteAcademy;
  }
  public set deleteAcademy(value: boolean) {
    this._deleteAcademy = value;
  }
  public get deleteEvent(): boolean {
    return this._deleteEvent;
  }
  public set deleteEvent(value: boolean) {
    this._deleteEvent = value;
  }
  public get addMaintenance(): boolean {
    return this._addMaintenance;
  }
  public set addMaintenance(value: boolean) {
    this._addMaintenance = value;
  }

  public get editMaintenance(): boolean {
    return this._editMaintenance;
  }
  public set editMaintenance(value: boolean) {
    this._editMaintenance = value;
  }

  public get cloneMaintenance(): boolean {
    return this._cloneMaintenance;
  }
  public set cloneMaintenance(value: boolean) {
    this._cloneMaintenance = value;
  }

  public get cloneMaintenanceTranslations(): boolean {
    return this._cloneMaintenanceTranslations;
  }
  public set cloneMaintenanceTranslations(value: boolean) {
    this._cloneMaintenanceTranslations = value;
  }

  public get addMaintenanceCheck(): boolean {
    return this._addMaintenanceCheck;
  }
  public set addMaintenanceCheck(value: boolean) {
    this._addMaintenanceCheck = value;
  }

  public get editMaintenanceCheck(): boolean {
    return this._editMaintenanceCheck;
  }
  public set editMaintenanceCheck(value: boolean) {
    this._editMaintenanceCheck = value;
  }

  public get deleteMedia(): boolean {
    return this._deleteMedia;
  }
  public set deleteMedia(value: boolean) {
    this._deleteMedia = value;
  }

  public get addProductFamily(): boolean {
    return this._addProductFamily;
  }
  public set addProductFamily(value: boolean) {
    this._addProductFamily = value;
  }

  public get editProductFamily(): boolean {
    return this._editProductFamily;
  }
  public set editProductFamily(value: boolean) {
    this._editProductFamily = value;
  }

  public get deleteProductFamily(): boolean {
    return this._deleteProductFamily;
  }
  public set deleteProductFamily(value: boolean) {
    this._deleteProductFamily = value;
  }

  public get addSerialNumberButton(): boolean {
    return this._addSerialNumberButton;
  }
  public set addSerialNumberButton(value: boolean) {
    this._addSerialNumberButton = value;
  }

  public get addButton(): boolean {
    return this._addButton;
  }
  public set addButton(value: boolean) {
    this._addButton = value;
  }

  public get importSerialNumberButton(): boolean {
    return this._importSerialNumberButton;
  }
  public set importSerialNumberButton(value: boolean) {
    this._importSerialNumberButton = value;
  }

  reset() {
    this.addSerial = false;
    this.editSerial = false;
    this.deleteSerial = false;

    this.addProcedure = false;
    this.editProcedure = false;
    this.cloneProcedure = false;
    this.deleteProcedure = false;

    this.cloneTranslations = false;

    this.addStep = false;
    this.editStep = false;
    this.deleteStep = false;

    this.addArticleCode = false;
    this.editArticleCode = false;
    this.deleteArticleCode = false;

    this.addDocument = false;
    this.editDocument = false;
    this.deleteDocument = false;

    this.addNews = false;
    this.editNews = false;
    this.deleteNews = false;

    this.addEvent = false;
    this.editEvent = false;
    this.deleteEvent = false;

    this.addAcademy = false;
    this.editAcademy = false;
    this.deleteAcademy = false;

    this.addMaintenance = false;
    this.editMaintenance = false;
    this.cloneMaintenance = false;
    this.cloneMaintenanceTranslations = false;
    this.deleteMaintenance = false;

    this.addMaintenanceCheck = false;
    this.editMaintenanceCheck = false;
    this.deleteMaintenanceCheck = false;

    this.deleteMedia = false;

    this.addProductFamily = false;
    this.editProductFamily = false;
    this.deleteProductFamily = false;

    this.addButton = false;
    this.addSerialNumberButton = false;
    this.importSerialNumberButton = false;
    this.addMedia = false;
  }
}

